import { render, staticRenderFns } from "./AllFixturesWidgetEfl.vue?vue&type=template&id=23b20aa6&scoped=true"
import script from "./AllFixturesWidgetEfl.vue?vue&type=script&lang=js"
export * from "./AllFixturesWidgetEfl.vue?vue&type=script&lang=js"
import style0 from "./AllFixturesWidgetEfl.vue?vue&type=style&index=0&id=23b20aa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b20aa6",
  null
  
)

export default component.exports